import PublicAdminPanelInstance from "../../api/PublicAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

export type PamAuthTokens = {
  AccessToken: string;
  ExpiresIn?: number;
  TokenType?: string;
  RefreshToken?: string;
  IdToken?: string;
};

export type PamAuthEnvelope<T> = {
  success: true;
  message?: string;
  msg_code: string;
  data: T;
};

export type PamMfaAssociateData = {
  secret_code: string;
  username: string;
};

export const associatePamMfa = async (
  enrollmentTicket: string,
): Promise<PamAuthEnvelope<PamMfaAssociateData>> => {
  const response = await PublicAdminPanelInstance.post<
    PamAuthEnvelope<PamMfaAssociateData>
  >(API_ROUTES.PAM_MFA_ASSOCIATE, {
    enrollment_ticket: enrollmentTicket,
  });
  return response.data;
};

export const verifyPamMfaEnrollment = async ({
  enrollmentTicket,
  code,
}: {
  enrollmentTicket: string;
  code: string;
}): Promise<PamAuthEnvelope<PamAuthTokens>> => {
  const response = await PublicAdminPanelInstance.post<
    PamAuthEnvelope<PamAuthTokens>
  >(API_ROUTES.PAM_MFA_VERIFY, {
    enrollment_ticket: enrollmentTicket,
    code,
  });
  return response.data;
};

export const challengePamMfa = async ({
  username,
  session,
  code,
}: {
  username: string;
  session: string;
  code: string;
}): Promise<PamAuthEnvelope<PamAuthTokens>> => {
  const response = await PublicAdminPanelInstance.post<
    PamAuthEnvelope<PamAuthTokens>
  >(API_ROUTES.PAM_MFA_CHALLENGE, {
    user_name: username,
    session,
    code,
  });
  return response.data;
};
